import type { AnalysisMissionPreset } from '@daevio/shared';

/**
 * What someone types on the landing before signing up: the site and what the visitors should try. It travels
 * through sign-up in the query string of the new test (`/app/new?url=…&mission=…`), which reads the site at once.
 */
export type MissionChoice = 'browse' | AnalysisMissionPreset | 'custom';

export interface StartDraft {
  url: string;
  choice: MissionChoice;
  task: string;
}

export const EMPTY_DRAFT: StartDraft = { url: '', choice: 'browse', task: '' };

export function draftToQuery(d: StartDraft): string {
  const params = new URLSearchParams({ url: d.url.trim() });
  // "Browse" is the landing's default: without a choice the new test proposes the AI's mission.
  if (d.choice !== 'browse') params.set('mission', d.choice);
  if (d.choice === 'custom' && d.task.trim()) params.set('task', d.task.trim());
  return params.toString();
}
